import React from "react";
import { Card } from "react-bootstrap";
import classnames from "classnames";

import IconButton from "./IconButton";

const EditContainer = ({
  children,
  title,
  className,
  handleAdd,
  addDisabled,
  noAdd,
  addIcon="Plus",
  ...props
}) => {
  return (
    <Card className={classnames("mb-4", className)}>
      <Card.Body>
        <div className="d-flex justify-content-between align-items-center">
          <div className="edit-title">{title}</div>
          {!noAdd && (
            <IconButton
              onClick={handleAdd}
              disabled={addDisabled}
              icon={addIcon}
              size="2rem"
            />
          )}
        </div>
        {children}
      </Card.Body>
    </Card>
  );
};

export default EditContainer;
